module.exports = __webpack_public_path__ + "c8eef482ac448a91ecca9d008634c044.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-italic-webfont.woff
 ** module id = ./src/styles/fonts/lato/lato-italic-webfont.woff
 ** module chunks = 0
 **/